/**
 * TrendModa — Akıllı Arama + Keşfet Paneli
 * Boş inputta focus → Keşfet paneli (koleksiyonlar + popüler ürünler)
 * Yazıldığında → predictive search sonuçları
 */
(function () {
  'use strict';

  var input = document.getElementById('tySearchInput');
  var dropdown = document.getElementById('tySearchDropdown');
  if (!input || !dropdown) return;

  var searchForm = document.getElementById('tySearchForm');
  var debounceTimer;
  var currentQuery = '';

  // Dropdown açık/kapalı durumunu search box'a yansıt
  function syncOpenClass() {
    if (!searchForm) return;
    if (dropdown.style.display === 'block') {
      searchForm.classList.add('ty-search--open');
    } else {
      searchForm.classList.remove('ty-search--open');
    }
  }

  function showDropdown() {
    dropdown.style.display = 'block';
    syncOpenClass();
  }

  function hideDropdown() {
    dropdown.style.display = 'none';
    syncOpenClass();
  }

  // ===== PARA FORMATLAMA =====
  function parsePrice(val) {
    if (!val && val !== 0) return 0;
    var str = String(val).trim();
    // Eğer nokta veya virgül varsa, zaten bölünmüş/formatlanmış kabul et
    var isDivided = str.includes('.') || str.includes(',');
    var num = parseFloat(str.replace(/[^0-9.-]+/g, ""));
    if (isNaN(num)) return 0;
    return isDivided ? num : num / 100;
  }

  function formatMoney(val) {
    var amount = parsePrice(val);
    var formatted = amount.toFixed(2).replace('.', ',');
    var parts = formatted.split(',');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    formatted = parts.join(',');
    return formatted + ' ₺';
  }

  // ===== KEŞFET VERİLERİ (Liquid ile enjekte edilir) =====
  var discoverData = null;
  try {
    var el = document.getElementById('tyDiscoverData');
    if (el) discoverData = JSON.parse(el.textContent);
  } catch (e) { /* ignore */ }

  // ===== KEŞFET PANELİ =====
  function renderDiscover() {
    if (!discoverData) {
      hideDropdown();
      return;
    }
    var html = '';

    // Başlık
    html += '<div class="ty-discover-header">' +
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#F27A1A" stroke-width="2"><circle cx="12" cy="12" r="10"/><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"/></svg>' +
      '<span>Keşfet</span>' +
    '</div>';

    // Koleksiyonlar
    if (discoverData.collections && discoverData.collections.length) {
      html += '<div class="ty-discover-section">';
      html += '<div class="ty-discover-cats">';
      discoverData.collections.forEach(function (c) {
        html += '<a href="' + c.url + '" class="ty-discover-cat">' +
          '<span class="ty-discover-cat__emoji">' + c.emoji + '</span>' +
          '<span class="ty-discover-cat__name">' + c.title + '</span>' +
        '</a>';
      });
      html += '</div></div>';
    }

    // Popüler Ürünler
    if (discoverData.popular && discoverData.popular.length) {
      html += '<div class="ty-discover-section">';
      html += '<div class="ty-discover-section-title">' +
        '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>' +
        'Popüler Ürünler</div>';
      html += '<div class="ty-discover-products">';
      discoverData.popular.forEach(function (p) {
        var pPrice = parsePrice(p.price);
        var pCompare = parsePrice(p.compare_price);
        var priceHtml = '';
        
        if (pCompare > pPrice) {
          priceHtml = '<span class="ty-search-result__price ty-search-result__price--sale">' + formatMoney(p.price) + '</span>' +
            '<span class="ty-search-result__price ty-search-result__price--compare">' + formatMoney(p.compare_price) + '</span>';
        } else {
          priceHtml = '<span class="ty-search-result__price">' + formatMoney(p.price) + '</span>';
        }
        html += '<a href="' + p.url + '" class="ty-search-result">' +
          (p.image ? '<img class="ty-search-result__img" src="' + p.image + '" alt="' + (p.title || '') + '" loading="lazy">' : '<div class="ty-search-result__img"></div>') +
          '<div class="ty-search-result__info">' +
            (p.vendor ? '<div class="ty-search-result__vendor">' + p.vendor + '</div>' : '') +
            '<div class="ty-search-result__title">' + (p.title || '') + '</div>' +
            '<div class="ty-search-result__price-wrapper">' + priceHtml + '</div>' +
          '</div></a>';
      });
      html += '</div></div>';
    }

    if (!html) {
      hideDropdown();
      return;
    }

    dropdown.innerHTML = html;
    showDropdown();
  }

  // ===== ARAMA SONUÇLARI =====
  function renderResults(data) {
    var html = '';

    if (data.resources && data.resources.results) {
      var results = data.resources.results;

      if (results.products && results.products.length) {
        html += '<div class="ty-search-section-title">Ürünler</div>';
        results.products.slice(0, 8).forEach(function (p) {
          var img = p.image ? p.image : (p.featured_image ? p.featured_image.url + '&width=88' : '');
          var pPrice = parsePrice(p.price);
          var pCompare = parsePrice(p.compare_at_price);

          var priceHtml = '';
          if (pCompare > pPrice) {
            var discountPct = Math.round((1 - pPrice / pCompare) * 100);
            priceHtml = '<span class="ty-search-result__price ty-search-result__price--sale">' + formatMoney(p.price) + '</span>' +
              '<span class="ty-search-result__price ty-search-result__price--compare">' + formatMoney(p.compare_at_price) + '</span>';
            if (discountPct > 0) {
              priceHtml += '<span class="ty-search-result__discount-badge">%' + discountPct + '</span>';
            }
          } else {
            priceHtml = '<span class="ty-search-result__price">' + formatMoney(p.price) + '</span>';
          }

          html += '<a href="' + p.url + '" class="ty-search-result">' +
            (img ? '<img class="ty-search-result__img" src="' + img + '" alt="' + (p.title || '') + '" loading="lazy">' : '<div class="ty-search-result__img"></div>') +
            '<div class="ty-search-result__info">' +
              '<div class="ty-search-result__title">' + (p.title || '') + '</div>' +
              '<div class="ty-search-result__price-wrapper">' + priceHtml + '</div>' +
            '</div></a>';
        });
      }
    }

    if (!html) {
      html = '<div class="ty-search-no-results">🔍 "' + currentQuery + '" için sonuç bulunamadı</div>';
    }

    dropdown.innerHTML = html;
    showDropdown();
  }

  // ===== ARAMA FETCH =====
  function fetchSuggestions(q) {
    currentQuery = q;
    if (q.length < 2) {
      renderDiscover();
      return;
    }

    var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=product' +
      '&resources[limit]=8' +
      '&resources[options][unavailable_products]=last';

    // Skeleton loading
    var skeletonHtml = '<div class="ty-search-skeleton">';
    for (var i = 0; i < 5; i++) {
      skeletonHtml += '<div class="ty-search-skeleton__item">' +
        '<div class="ty-search-skeleton__img skeleton-shimmer"></div>' +
        '<div class="ty-search-skeleton__info">' +
          '<div class="ty-search-skeleton__line ty-search-skeleton__line--mid skeleton-shimmer"></div>' +
          '<div class="ty-search-skeleton__line ty-search-skeleton__line--short skeleton-shimmer"></div>' +
        '</div>' +
      '</div>';
    }
    skeletonHtml += '</div>';
    dropdown.innerHTML = skeletonHtml;
    showDropdown();

    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (currentQuery === q) renderResults(data);
      })
      .catch(function () {
        hideDropdown();
      });
  }

  // ===== EVENT LISTENERS =====
  input.addEventListener('input', function () {
    clearTimeout(debounceTimer);
    var q = input.value.trim();
    debounceTimer = setTimeout(function () { fetchSuggestions(q); }, 250);
  });

  input.addEventListener('focus', function () {
    var q = input.value.trim();
    if (q.length >= 2) {
      showDropdown();
    } else {
      renderDiscover();
    }
  });

  document.addEventListener('click', function (e) {
    if (!input.contains(e.target) && !dropdown.contains(e.target)) {
      hideDropdown();
    }
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { hideDropdown(); input.blur(); }
  });
})();
